import React, {Component} from "react";
import {observer} from "mobx-react";
import {instance, mesAutobind} from "@posco/posco-shared";

import MenuComponent from "./MenuComponent";
import ToptabComponent from "./ToptabComponent";
import PortalRepository from "../api/PortalRepository";
import O10g015460Container from "../../o10g015460/container/O10g015460Container";
import {Code020Util, Common} from "@plm/o10-share-front";

// 실제 url은 짧게 출력하기 위한 정규식.
const customRegExp = /[^\/\s]+\/(inner\/)?/g;

// 쿼리스트링 비교제외를 위한 정규식
const customRegExp2 = /(\?([^#\s]*))/g;


@mesAutobind
@observer
class PortalLayout extends Component {

  @instance(PortalRepository.instance)
  static instance;

  state = {
    topTabList: [],
    activePattMenuIdArray: [], //지금 보고있는 메뉴 표시용
    tabTabPattMenuIdArray: [], //탭에 추가되어있는 메뉴 표시용
    activePattMenuId1Array: [], // 지금 보고있는 메뉴 펼치기용

    // fontSize 기본값
    fontSize: "14px",

    // navigation onoff
    // 1단계가 완전히 열림, 2단계가 중간, 3단계가 버튼 하나
    //open, close, last
    nav: "open",

    // 메뉴 목록
    menuList: [],
    //즐겨찾기 목록
    favorMenuList: [],
    //프로젝트 넘버
    projectNumber: "",
    // session 보유 여부.
    loginSession: false,
    //통합검색 tab id
    searchTabId: 1,
    dwgSystemName : "",
    dwgSystemURL : "",
    kosisSystemName : "",
    kosisSystemURL : "",
    supSystemName : "",
    supSystemURL : "",
    jibanSystemName : "",
    jibanSystemURL : "",
    safeSystemName : "",
    safeSystemURL : "",
  };

  changeFontSize = (data) => {
    this.setState({fontSize: data});
  };

  changeNavState = (state) => {
    this.setState({nav: state});
  };


  removePotalTab(pageId) {
    this.closing(pageId);
  }

  //tabtabcomponent.js에 있는 closing는 고유한 pattMenuId로 비교해서 닫기때문에 재사용 안하고 pgmUrl에 pageId포함된거 닫는걸로 수정
  closing(pageId) {
    const tmp = this.state.topTabList.filter((props) => !props.pgmUrl.includes(pageId));
    //지금 보고있는 페이지를 닫은 거면
    if (!tmp.filter(item => item.active === true).length && tmp.length) {
      //마지막 페이지를 활성화
      tmp.forEach((props, index) => {
        index === tmp.length - 1 ? props.active = true : props.active = false;
      });
      //활성화된 마지막 페이지 히스토리 푸쉬
      this.props.history.push(tmp[tmp.length - 1].pgmUrl);
    }
    this.topTabListSet([...tmp]);
  }

  async addPotalTab(tabData) {
    console.log("tabData", tabData);
    if (!tabData) return;
    const url = tabData.url;
    const menuNm = tabData.menuNm;

    if (!url) return;
    const targetMenu = await this.getMenuDataFromPageId(this.getPageIdFromUrl(url));

    //메뉴데이터 없으면 받은 데이터로 설정
    const pgmUrl = url.replaceAll("/o10t01-front", "");
    let menuData = {};
    if (!targetMenu) {
      menuData = {
        menuNm: menuNm || "-", //DEV-메뉴리스트에 없는 페이지
        pattMenuId: this.getPageIdFromUrl(url), //pattMenuId는 모르므로 임시로 pageid넣음
        pattMenuId1: this.getPageIdFromUrl(url), //pattMenuId1는 모르므로 임시로 pageid넣음
        pgmUrl: pgmUrl,
        pageId: this.getPageIdFromUrl(url)
      };
    } else {
      menuData = {
        menuNm: targetMenu.menuNm,
        pattMenuId: targetMenu.pattMenuId,
        pattMenuId1: targetMenu.pattMenuId1,
        pgmUrl: pgmUrl,
        pageId: targetMenu.pageId
      };
    }

    this.adding("", menuData);
    this.props.history.push(pgmUrl);
  }

  //언어설정
  setLanguage(lang) {
    localStorage.setItem("Posco.Multilang.Code", lang);
    window.location.reload(true);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //사업메뉴 바인딩 하면서 projectNumber 바뀌므로 componentDidUpdate에서 링크 역분해함
    if ((this.state.projectNumber !== prevState.projectNumber) || (this.state.menuList !== prevState.menuList)) {
      //링크역분해
      this.decodeUrlAndTopTabListSet();
    }
  }

  componentDidMount() {
    //사업정보 삭제 (iframe 아닐 시에만, 로컬 실행시 내부에 t가 불러와져 세션을 자꾸 지워서 iframa여부 체크 추가함)
    if (self === top) sessionStorage.clear();

    this.userInfo = Common.PotalUtil.getStorageItem("Posco.auth.userInfo");
    this.userId = Common.PotalUtil.getStorageItem("Posco.auth.userId");
    this.userMenu = Common.PotalUtil.getStorageItem("Posco.auth.userMenu");
    const lang = localStorage.getItem("Posco.Multilang.Code") || "ko";
    sessionStorage.setItem("Posco.Multilang.Code", lang);

    if (!this.userId) this.setState({loginSession: false});

    //로그인에서 가져온 일반 메뉴 menuList에 set
    if (this.userMenu) this.setMenuList(this.userMenu);

    //링크 분해하여 사업코드가 있는 링크인지 체크, 사업정보 api 통신, 사업메뉴 set
    if (this.userId) this.setProjectMenuList();


    //iframe 이벤트 수신
    window.addEventListener("message", (event) => {
      if (event.data.addPotalTab) this.addPotalTab(event.data.addPotalTab);
      if (event.data.removePotalTab) this.removePotalTab(event.data.removePotalTab);
      if (event.data.redirectionPotal) window.location.href = event.data.redirectionPotal;
      if (event.data.pushPotal) this.props.history.push(event.data.pushPotal);
    }, false);


    // pageId로 pattMenuId알아내니까 pageId 같은거 두개있을때 문제생기므로 기능 주석처리
    // //라우터 이동 체크
    // this.props.history.listen(async () => {
    //   if (this.props.history.action === "POP" || this.props.history.action === "PUSH") {
    //
    //     //뒤로가기 한 경우
    //     //주소에서 MenuData 추출
    //     const targetMenu = await this.getMenuDataFromPageId(this.getPageIdFromUrl(window.location.pathname));
    //     if (!targetMenu) return;
    //     //targetMenu.pattMenuId가 topTabList에 있은지 filter
    //     const overlap = this.state.topTabList.filter(props => props.pattMenuId === targetMenu.pattMenuId);
    //     if (overlap.length) {
    //       //있으면 그 props.active만 true로 바꿔서 set
    //       this.state.topTabList.forEach(props => props.pattMenuId === targetMenu.pattMenuId ? props.active = true : props.active = false);
    //       //중복 있는경우 위에서 정렬한 this.state.topTabList로 set
    //       this.topTabListSet([...this.state.topTabList]);
    //     }
    //
    //   }
    // });
    //즐겨찾기 불러오기
    this.setFavorMenuList();
    // 투자관련 링크 바로가기
    this.setShortCutURLInfo();
  }

  // 투자관련 링크 바로가기
  setShortCutURLInfo() {
    Code020Util.findByRollCodeCode020("SHORT_CUT_URL").then(data => {

      for(let i=0; i<data.length; i++) {
        let linkUrl = data[i].attribute2 === "" ? data[i].attribute1 : data[i].attribute2 + encodeURIComponent(data[i].attribute1);
        console.log("### " + data[i].value + " URL ::: " + linkUrl);

        if(data[i].value === "URL_DWG_SYS") {
          this.setState({dwgSystemName: data[i].text, dwgSystemURL: linkUrl});
        } else if(data[i].value === "URL_KOSIS") {
          this.setState({kosisSystemName: data[i].text, kosisSystemURL: linkUrl});
        } else if(data[i].value === "URL_SUP_SYS") {
          this.setState({supSystemName: data[i].text, supSystemURL: linkUrl});
        } else if(data[i].value === "URL_JIBAN_SYS") {
          this.setState({jibanSystemName: data[i].text, jibanSystemURL: linkUrl});
        } else if(data[i].value === "URL_SAFTY") {
          this.setState({safeSystemName: data[i].text, safeSystemURL: linkUrl});
        }
      }

    });
  }

  setFavorMenuList() {
    PortalRepository.instance.getFavorites()
      .then(result => {
        if (result.status === 200) {
          console.log("getFavorites", result);
          this.setState({favorMenuList: result.data});
        }
      });
  }

  addFavorMenuList(pattMenuId) {
    PortalRepository.instance.addFavorites(pattMenuId)
      .then(result => {
        if (result.status === 200) {
          console.log("addFavorMenuList", result);
          this.setFavorMenuList();
        }
      });
  }

  deleteFavorMenuList(pattMenuId) {
    PortalRepository.instance.deleteFavorites(pattMenuId)
      .then(result => {
        if (result.status === 200) {
          console.log("deleteFavorMenuList", result);
          this.setFavorMenuList();
        }
      });
  }

  setProjectMenuList() {
    //?menu=off 쿼리스트링있으면 사업메뉴 조회 안함
    if (new URLSearchParams(location.search).get("menu") === "off") return;

    //링크 분해하여 사업코드가 있는 링크인지 체크, 사업정보 api 통신, 사업메뉴 set하는 함수

    const pathname = window.location.pathname;
    const pathnameArray = window.location.pathname.split("/");

    //일반 메뉴인지 사업 메뉴인지 체크
    // const regex = /^[A-Z]{4}/; // 시작 4자리가 영문 대문자인지 체크하는 정규식 ex)KABH2020015
    const regex = /^[A-Z]{3}/; // 시작 3자리가 영문 대문자인지 체크하는 정규식 ex)HCV20001
    const projectNumArray = pathnameArray.filter(item => regex.test(item));
    //프로젝트 코드가 있으면
    if (projectNumArray[0]) {
      //사업정보 받아오는 api 호출
      PortalRepository.instance.onGetProjectMenu(projectNumArray[0])
        .then(result => {
          if (result) {
            //사업 정보 sessionStorage 넣기
            result.data.nameValues.forEach(item => {
              sessionStorage.setItem(item.name, typeof item.value === "object" ? JSON.stringify(item.value) : item.value);
            });
            sessionStorage.setItem("invbpNameArray", result.data.nameValues.map(item => item.name));
            //사업자 메뉴를 메뉴 리스트에 셋팅
            // 사용자 정보 + 사업 번호에 따라 사용 가능한 사업메뉴가 다르므로 사업메뉴, 일반 메뉴 따로 관리하지 않고 menulist state 덮어쓰기함
            this.setMenuList(Common.PotalUtil.getStorageItem("Posco.auth.userMenuByMenuCode"));
            //사업정보 가져오기 성공, 프로젝트넘버 state에 projectNumber set
            this.setState({projectNumber: projectNumArray[0]});
          }
        });
    } else {
      this.setState({projectNumber: ""});
    }
  }

  // ********* 통합 검색
  searchStartApi(keyword) {
    const param = {
      keyword: keyword
    };
    const keywordName = keyword.length > 5 ? keyword.substr(0, 5) + "..." : keyword;

    if (keyword) {
      this.topTabListSet([...this.state.topTabList, {
        pattMenuId: `o10g014310_${Number(this.state.searchTabId)}`,
        pattMenuId1: `o10g014310_${Number(this.state.searchTabId)}`,
        menuNm: "PLM2.0 통합검색",
        active: true,
        pgmUrl: "/o10g01-front/o10g014310?param=" + encodeURI(JSON.stringify(param))
      }]);
      this.setState({searchTabId: Number(this.state.searchTabId) + 1});
    } else {
      alert("검색어를 입력해주세요.");
    }
  }

  // ********* 상세 검색
  detailSearchApi(params) {
    this.topTabListSet([...this.state.topTabList, {
      pattMenuId: `o10g014310_${Number(this.state.searchTabId)}`,
      pattMenuId1: `o10g014310_${Number(this.state.searchTabId)}`,
      menuNm: "PLM2.0 통합검색",
      active: true,
      pgmUrl: "/o10g01-front/o10g014310?param=" + encodeURI(JSON.stringify(params))
    }]);
    this.setState({searchTabId: Number(this.state.searchTabId) + 1});
  }

  //** 진행구분api
  onFindInvestProgLevelNamLov(){
    PortalRepository.instance.onFindInvestProgLevelNamLov()
    .then(result => {
      if (result.status === 200) {
          let list = [];
          result.data.forEach(function (v, idx) {
            list.push({
              text: v.prCombineStartCdName,
              key: v.itastCode,
              value: v.prCombineStartCdName
            });
          });
          this.setState({[`investProgLevelNameList`]: list});
      }
    });
  }

  getPageIdFromUrl(url) {
    console.log("getPageIdFromUrl url", url);
    //쿼리스트링 있을수 있으니 쿼리스트링 잘라냄
    const urlArray = url && url.split("?")[0].split("/");
    //url주소가 기준에 맞지않게 짧거나, o10t01-front를 포함하지 않으면 빈값 리턴
    if (!(urlArray.length > 3 && url.includes("o10t01-front"))) {
      return;
    }

    //URL 구조상 index 3번이 pageId이므로 return
    return urlArray[3];
  }

  async getMenuDataFromPageId(pageId) {
    console.log("pageId", pageId);
    if (!pageId) return;

    let userMenu = {};
    userMenu = this.state.projectNumber ? Common.PotalUtil.getStorageItem("Posco.auth.userMenuByMenuCode") : Common.PotalUtil.getStorageItem("Posco.auth.userMenu");
    console.log("userMenu", userMenu);
    if (!userMenu) return;
    //  메뉴 리스트에 있는 pageId인지 체크
    let hasUserMenu = false;
    let targetMenu = {};
    await userMenu.forEach((item, index) => {
      if (item.pageId === pageId) {
        hasUserMenu = true;
        targetMenu = JSON.parse(JSON.stringify(userMenu[index])); //깊은복사
        // console.log('targetMenu', targetMenu)
      }
    });
    //id가 일치하는 메뉴가 있으면 해당 메뉴데이터 리턴
    if (hasUserMenu) {
      return targetMenu;
    }
  }


  async decodeUrlAndTopTabListSet() {
    //루트로 들어왔을떄는 url역분해 안함, MenuList에 pattMenuId가 빈게 있을경우 그걸 탭으로 띄우기 때문.
    if (window.location.pathname === "/o10t01-front" || window.location.pathname === "/o10t01-front/") {
      return;
    }
    const targetMenu = await this.getMenuDataFromPageId(this.getPageIdFromUrl(window.location.pathname));
    console.log("targetMenu", targetMenu);
    if (targetMenu) {
      //  iframe정보값 변경
      targetMenu.pgmUrl = window.location.pathname.replace("/o10t01-front", "");
      //  있으면 해당 탭 띄우기, 기존 탭들은 다 닫힌다
      this.topTabListSet([{
        pattMenuId: targetMenu.pattMenuId,
        pattMenuId1: targetMenu.pattMenuId1,
        menuNm: targetMenu.menuNm,
        active: true,
        //  아이프레임 주소 정보
        //링크 넣고 들어오는 역분해시에는 쿼리스트링 달고 들어올수있으므로 window.location.search 추가
        pgmUrl: targetMenu.pgmUrl + window.location.search
      }]);
    } else {
      //  없으면 404 탭추가
      this.topTabListSet([{
        // pattMenuId: "",
        // pattMenuId1: "",
        // menuNm: "404",
        // active: true,
        // //  아이프레임 주소 정보
        // pgmUrl: "/o10t01-front/404",

        //TODO 개발 편의성을 위해 주소 가 메뉴목록에 없어도 iframe뜨게 수정
        pattMenuId: window.location.pathname.replace("/o10t01-front", ""),
        pattMenuId1: window.location.pathname.replace("/o10t01-front", ""),
        menuNm: "-", //DEV-메뉴리스트에 없는 페이지
        active: true,
        // 아이프레임 주소 정보
        //링크 넣고 들어오는 역분해시에는 쿼리스트링 달고 들어올수있으므로 window.location.search 추가
        pgmUrl: window.location.pathname.replace("/o10t01-front", "") + window.location.search
      }]);
    }
  }


  onLogin(id) {
    console.log("PortalLayout.onLogin id ==> ", id);
  }

  setMenuList(menuData) {
    const stateMenu = {
      depth1: [],
      depth2: []
    };
    menuData.map((item) => {
      if (item.depth1 === 1) {
        stateMenu.depth1.push(item);
      } else if (item.depth1 === 2) {
        stateMenu.depth2.push(item);
      }
    });
    //level2를 level1의 depth2에 합치기
    stateMenu.depth1.map((depth1 => {
      stateMenu.depth2.map((depth2 => {
        if (depth1.pattMenuId === depth2.pattMenuId1) {
          depth1["depth2"] ? depth1["depth2"].push(depth2) : depth1["depth2"] = [depth2];
        }
      }));
    }));
    this.setState({
      loginSession: true,
      menuList: stateMenu.depth1,
      topTabList: [{...stateMenu.depth1[0], active: true}]
    });
  }

  adding(props, menuData) {
    let menuNm, pattMenuId, pattMenuId1, pgmUrl, pageId;
    if (menuData) {
      menuNm = menuData.menuNm;
      pattMenuId = menuData.pattMenuId;
      pattMenuId1 = menuData.pattMenuId1;
      pgmUrl = menuData.pgmUrl;
      pageId = menuData.pageId;
    } else {
      menuNm = props.target.innerText;
      pattMenuId = props.target.getAttribute("pattmenuid");
      pattMenuId1 = props.target.getAttribute("pattmenuid1");
      pgmUrl = props.target.getAttribute("pgmurl");
      pageId = props.target.getAttribute("pageid");
    }

    // ---- begin ::  popup 새창으로 여는 페이지 --- //
    if (pageId === "o10g011080") {
      window.open(pgmUrl, "o10g011080", "width=510, height=610, scrollbars = no");
      // window.open("http://localhost:3000/o10g011080", "o10g011080", "width=510, height=610, scrollbars = no");
      return;
    }

    //e-vid
    if (pattMenuId === "A0070") {
      window.open(pgmUrl, pattMenuId);
      return;
    }
    // ---- end ::  popup 새창으로 여는 페이지 --- //


    // ********** backup code :: 중복있을시 중복탭 여는 코드 ********** //
    //중복값 active true, 나머지는 active false로 정렬 후 중복값을 overlap에 저장
    // const
    //   overlap = this.state.topTabList.filter(props => props.pattMenuId === pattMenuId ? props.active = true : props.active = false);
    // if (overlap.length) {
    //   //중복 있는경우 위에서 정렬한 this.state.topTabList로 set
    //   this.topTabListSet([...this.state.topTabList]);
    // } else {
    //   //중복 없는 경우 추가해서 set
    //   this.topTabListSet([...this.state.topTabList, {
    //     pattMenuId: pattMenuId,
    //     pattMenuId1: pattMenuId1,
    //     menuNm: menuNm,
    //     active: true,
    //     //  아이프레임 주소 정보
    //     pgmUrl: pgmUrl,
    //   }]);
    // }
    // ********** backup code :: 중복있을시 중복탭 여는 코드 ********** //

    //중복있는경우 새로 여는것으로 코드 수정
    const noOverLap = this.state.topTabList.filter(props => props.pattMenuId !== pattMenuId).map(props => {
      return {...props, active: false};
    });
    //이미 열려있는 창 메뉴 눌렀을시 this.state.topTabList가 변하지않았다고 인식하는듯, 새로고침 안됨
    //중복값 뺀 topTabList을 setState한뒤 콜백으로 누른 메뉴 추가한 topTabList를 다시 setState하는것으로 수정
    this.setState({topTabList: [...noOverLap]}, () => {
      this.topTabListSet([...noOverLap, {
        pattMenuId: pattMenuId,
        pattMenuId1: pattMenuId1,
        menuNm: menuNm,
        active: true,
        pgmUrl: pgmUrl
      }]);
    });
  }

  topTabListSet(array) {
    this.setState({topTabList: array}, () => {
      this.setState({
        activePattMenuIdArray: this.state.topTabList.filter(item => item.active).map(item => item.pattMenuId),
        activePattMenuId1Array: this.state.topTabList.filter(item => item.active).map(item => item.pattMenuId1),
        tabTabPattMenuIdArray: this.state.topTabList.map(item => item.pattMenuId)
      });
    });
  }

  render() {
    const {loginSession, fontSize, nav, menuList, favorMenuList, topTabList} = this.state;
    const loginSession2 = Common.PotalUtil.getStorageItem("access_Token");

    return (
      loginSession || loginSession2 ? (
        <div className={fontSize === "12px" ? "appWrap font12" : fontSize === "16px" ? "appWrap font16" : "appWrap"}>
          <MenuComponent
            changeNavState={this.changeNavState}
            changeFontSize={this.changeFontSize}
            fontSizeState={fontSize}
            navState={nav}
            menuList={menuList}
            favorMenuList={favorMenuList}
            adding={this.adding}
            projectNumber={this.state.projectNumber}
            //통합 검색 & 상세검색
            searchStartApi={this.searchStartApi}
            detailSearchApi={this.detailSearchApi}
            onFindInvestProgLevelNamLov={this.onFindInvestProgLevelNamLov}
            investProgLevelNameList={this.state.investProgLevelNameList}
            activePattMenuIdArray={this.state.activePattMenuIdArray}
            activePattMenuId1Array={this.state.activePattMenuId1Array}
            tabTabPattMenuIdArray={this.state.tabTabPattMenuIdArray}
            dwgSystemName={this.state.dwgSystemName}
            dwgSystemURL={this.state.dwgSystemURL}
            kosisSystemName={this.state.kosisSystemName}
            kosisSystemURL={this.state.kosisSystemURL}
            supSystemName={this.state.supSystemName}
            supSystemURL={this.state.supSystemURL}
            jibanSystemName={this.state.jibanSystemName}
            jibanSystemURL={this.state.jibanSystemURL}
            safeSystemName={this.state.safeSystemName}
            safeSystemURL={this.state.safeSystemURL}
            //언어설정
            setLanguage={this.setLanguage}
          />
          <ToptabComponent
            topTabList={topTabList}
            navState={nav}
            topTabListSet={this.topTabListSet}
            projectNumber={this.state.projectNumber}
            history={this.props.history}
            favorMenuList={this.state.favorMenuList}
            addFavorMenuList={this.addFavorMenuList}
            deleteFavorMenuList={this.deleteFavorMenuList}
          >
            <div style={{height: "100%", position: "relative"}}>
              {this.state.topTabList.map((list) => {
                // active된 화면의 name으로 브라우저 HTML titls 변경
                if(list.active) {
                  document.title = list.menuNm;
                }

                if (self === top) {
                  return (
                    <iframe
                      id={`tab_iframe_${list.pattMenuId}`}
                      key={list.pattMenuId}
                      src={list.pgmUrl}
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        display: list.active ? "block" : "none"
                      }}
                    />
                  );
                } else {
                  return false;
                }
              })}
            </div>
          </ToptabComponent>
        </div>
      ) : (
        // <Login
        //   isSSO={true}
        //   mainPath={'/'}
        //   onLogin={this.onLogin}
        // />
        <O10g015460Container/>
      )
    );
  }
}

export default PortalLayout;
